import { useEffect, useState } from 'react';
import { FormControlLabel, FormGroup, Switch, SwitchProps } from '@mui/material';
import { useField } from '@unform/core';

type TVSwitchProps = SwitchProps & {
  name: string;//nome do switch
  label: string;//nome do label que fica ao lado
}
export const VSwitch: React.FC<TVSwitchProps> = ({ name, label, ...rest }) => {
  const { fieldName, registerField, defaultValue } = useField(name);

  const [value, setValue] = useState(defaultValue || false);// state sempre inicializar com algum valor caso seja cadastro

  useEffect(() => {
    registerField({
      name: fieldName,// nome do switch
      getValue: () => value,
      setValue: (_, newValue) => setValue(newValue),
    });
  }, [registerField, fieldName, value]);

  return (
    <FormGroup>
        <FormControlLabel control={
            <Switch
                {...rest}

                defaultValue={defaultValue}

                checked={value}
                onChange={e => setValue(e.target.checked)}
            />
            }
            label={label} 
        />
    </FormGroup>
  );
};